module.exports = __webpack_public_path__ + "img/Comic08-2.f343d5cb.png";